import cloneDeep from 'lodash/fp/cloneDeep'
import {
  CLEAR_MARKER_ADDRESS,
  CLEAR_MARKER_ADDRESS_DONE,
  SET_IS_SEARCHING,
  SET_MARKER_ADDRESS,
  SET_LOCATION_ENABLED_WARNING,
  INITIALIZE_MAP_WITH_LOCATION
} from './LocationContainerActions'

const initialState = {
  isSearching: false,
  showLocationWarning: false,
  markerAddress: '',
  shouldClear: false,
  initialiseMap: false,
  initialLocation: {
    lat: -30.111500,
    lng: 22.971163
  }
}

export default function (state = initialState, action) {
  var newState = {
    isSearching: state.isSearching,
    showLocationWarning: state.showLocationWarning,
    markerAddress: state.markerAddress,
    shouldClear: state.shouldClear,
    initialiseMap: state.initialiseMap,
    initialLocation: state.initialLocation
  }

  switch (action.type) {

    case SET_IS_SEARCHING: {
      newState.isSearching = action.value
      return newState
    }
    case SET_LOCATION_ENABLED_WARNING: {
      newState.showLocationWarning = action.value
      return newState
    }
    case SET_MARKER_ADDRESS: {
      newState.markerAddress = action.value
      return newState
    }
    case CLEAR_MARKER_ADDRESS: {
      newState = cloneDeep(initialState)
      newState.shouldClear = true
      newState.initialiseMap = false
      return newState
    }
    case CLEAR_MARKER_ADDRESS_DONE: {
      newState.shouldClear = false
      return newState
    }
    case INITIALIZE_MAP_WITH_LOCATION: {
      newState.initialiseMap = true
      newState.initialLocation = action.location
      return newState
    }
  }
  return newState
}
